var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{attrs:{"show":_vm.show,"variant":"danger"}},[_c('h5',[_vm._v("Unknown SearchResultstype \""+_vm._s(_vm.resultType)+"\"")]),_c('pre',{staticClass:"text-inherit"},[_vm._v(_vm._s(_vm.results))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }